import React, { useState } from "react";
import MedicineStock from "../../../assets/images/icons/user-profile/MedicineStock.svg";
import { useNavigate } from "react-router-dom";
import PermissionWrapper from "../../../permission_advance/PermissionWrapper";
import ServiceUsersOptionsBlocks from "../../../components/user-detail/ServiceUsersOptionsBlocks";
import Layout from "../../../components/layouts/Layout";
function EmarSettings() {
    const navigate = useNavigate();
    const handleRowClickEmarSettings = (url) => {
        navigate(url);
    };
    return (
        <>
            <Layout pageTitleText="Settings">
                <div className="scheduleBlocks careplanOptions">
                    <div className="row">
                        <PermissionWrapper title="Super Admin" action="update">
                            <div className="col-md-3 col-sm-6">
                                <ServiceUsersOptionsBlocks
                                    blockIcon={MedicineStock}
                                    heading={"Medicine List"}
                                    linkedComponent={() => { handleRowClickEmarSettings("/medicine-list") }}
                                />
                            </div>
                        </PermissionWrapper>

                    </div>
                </div>
            </Layout>
        </>
    )
}

export default EmarSettings